export const ADMIN_MANAGE_USERS_URL = '/admin/users';
export const ADMIN_URL = '/admin';

export const changeUsernameSymbolsRegex = /^[\d.A-Za-z]+$/;

export const DELETE_ACCOUNT = 'DELETE ACCOUNT';
